// extracted by mini-css-extract-plugin
export var icon = "_a-1";
export var subtext = "_a-0";